export class Representation {
  id: number;
  name: string; 
  order: number;
}
